export const galleryPaths = {
  base: 'gallery',
  galleryHome: 'galleryHome',
  gallery: 'gallery',
  ourHistory: 'our-history-',
  ourHistoryG1: 'our-history-g1',
  historyTimeline: 'history-timeline',
  eventGallery: 'event-gallery',
  allPhotosEvent: 'all-photos-event',
};

export const galleryRoutes = {
  galleryHome: `/${galleryPaths.base}/${galleryPaths.galleryHome}`,
  galleries: `/${galleryPaths.base}/${galleryPaths.gallery}`,
  ourHistory: `/${galleryPaths.base}/${galleryPaths.ourHistory}`,
  ourHistoryG1: `/${galleryPaths.base}/${galleryPaths.ourHistoryG1}`,
  historyTimeline: `/${galleryPaths.base}/${galleryPaths.historyTimeline}`,
  eventGallery: `/${galleryPaths.base}/${galleryPaths.eventGallery}`,
  allPhotosEvent: `/${galleryPaths.base}/${galleryPaths.allPhotosEvent}`,
};
